define([
	"dojo/_base/declare",
	"./_RevisedGapMixin",
	"./RevisedPattern"
], function(declare,_RevisedGapMixin,RevisedPattern) {

	return declare([RevisedPattern,_RevisedGapMixin]);
});